<template>
  <div>
    <h2 class="step-name">Drug Allocations</h2>

    <div class="step-section">
      <ul class="nav nav-tabs" role="tablist">
        <li v-for="tab in tabs" :class="(activeTab == tab) ? 'active':''" :key="tab" role="presentation">
          <a @click="changeTab(tab)" role="tab">{{ tab }}</a>
        </li>
      </ul>
    </div>

    <div class="step-section" v-if="activeTab == 'Sheep'">
      <drug-allocation-inputs animalType="sheep"
                              :drugGroups="getFieldValue('DRUG_GROUPS').sheep"
                              :lastYearUsage="getFieldValue('LAST_YEAR_USAGE').sheep">
      </drug-allocation-inputs>
    </div>

    <div class="step-section" v-if="activeTab == 'Beef'">
      <drug-allocation-inputs animalType="beef"
                              :drugGroups="getFieldValue('DRUG_GROUPS').beef"
                              :lastYearUsage="getFieldValue('LAST_YEAR_USAGE').beef">
      </drug-allocation-inputs>
    </div>

    <div class="step-section" v-if="activeTab == 'Deer'">
      <drug-allocation-inputs animalType="deer"
                              :drugGroups="getFieldValue('DRUG_GROUPS').deer"
                              :lastYearUsage="getFieldValue('LAST_YEAR_USAGE').deer">
      </drug-allocation-inputs>
    </div>

    <div class="step-section" v-if="activeTab == 'DairySupport'">
      <drug-allocation-inputs animalType="dairy_support"
                              :drugGroups="getFieldValue('DRUG_GROUPS').dairy_support"
                              :lastYearUsage="getFieldValue('LAST_YEAR_USAGE').dairy">
      </drug-allocation-inputs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationInputs from './DrugAllocationInputs'


export default {
  name: 'DrugAllocations',
  mixins: [ baseComponent ],
  components: {
    DrugAllocationInputs,
  },
  data() {
    return {
      tabs: [],
      activeTab: '',
    }
  },
  created: function() {
    if (this.$store.state.currentConsult.models.ClientDetails.is_sheep) {
      this.tabs.push('Sheep')
    }
    if (this.$store.state.currentConsult.models.ClientDetails.is_beef) {
      this.tabs.push('Beef')
    }
    if (this.$store.state.currentConsult.models.ClientDetails.is_deer) {
      this.tabs.push('Deer')
    }
    if (this.$store.state.currentConsult.models.ClientDetails.is_dairy_support) {
      this.tabs.push('DairySupport')
    }
    this.activeTab = this.tabs[0]
  },
  methods: {
    changeTab: function(tab) {
      this.activeTab = tab
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['newAnimals', 'animals']),
  }
};
</script>

<style scoped>
.nav-tabs > li {
    float:none;
    display:inline-block;
    zoom:1;
}

.nav-tabs {
    text-align:center;
}
</style>
